import React, { useState, useEffect, useRef } from 'react';
import { connect, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { useHttp } from '../../hooks/httpHook';

import Direction from '../../components/Direction';
import Position from '../../components/Position';
import Currency from '../../components/Currency';
import City from '../../components/City';
import Stack from '../../components/Stack';
import Salary from '../../components/Salary';
import Onsite from '../../components/Onsite';
import SearchResultMob from '../SearchResultMob';
import label from '../../assets/logo1.SVG'
import robot from '../../assets/robot.PNG'
import filter from '../../assets/Filter.PNG'
import { Box } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Collapse from '@material-ui/core/Collapse';

import { searched, total } from '../../redux/actions/clsActions';
import { vacancies, direction, position, stack, salary, city } from '../../redux/actions/filterActions';
import { isMobile } from "react-device-detect";


const useStyles = makeStyles((theme) => ({
    root: {
        maxWidth: isMobile ? 375 : 397,
        minWidth: isMobile ? 375 : 397,
    },
    searchBtn: {
        width: isMobile ? 335 : 309,
        height: 58,
        borderRadius: '10px',
        marginLeft: isMobile ? 20 : 63,
        marginTop: 42,
        boxShadow: '0px 0px 15px rgba(60, 112, 241, 0.45)',
        '&:hover': {
            backgroundColor: '#F9521D'

        },
        textTransform: "none",
    },
    searchBtnEmpty: {
        width: isMobile ? 335 : 309,
        height: 58,
        borderRadius: '10px',
        marginLeft: isMobile ? 20 : 63,
        marginTop: 42,
        '&:hover': {
            backgroundColor: '#F9521D'

        },
        textTransform: "none",
    },
    clearBtn: {
        backgroundColor: '#ffffff',
        color: '#3C70F1',
        minWidth: 335,
        minHeight: 58,
        marginTop: 20,
        marginLeft: 20,
        borderRadius: 10,
        textTransform: "none",
        boxShadow: '0px 0px 15px rgba(60, 112, 241, 0.45)',
    },
    registrationLinkGroup: {
        marginTop: 22,
        marginLeft: isMobile ? 30 : 70,
    },
    regLink: {
        color: '#162946'
    },
    loginLink: {
        marginTop: 22,
        marginLeft: isMobile ? 119 : 92,
        color: '#162946'
    },
    aboutLink: {
        marginTop: 20,
        marginLeft: isMobile ? 20 : 61,
    },
    emailLink: {
        marginTop: 20,
        marginLeft: 29,
    },
    footer: {
        marginTop: 29.91,
        marginLeft: isMobile ? 20 : 61,

    },
    radio: {
        // '&$checked': {
        //     color: '#2572FA',
        // },
        "& svg": {
            width: "0.5em",
            height: "0.5em"
        }
    },
    radiogr: {
        marginTop: 23,
    },
    img: {
        height: 23,
        width: 93,
        marginLeft: isMobile ? 20 : 64,
        marginTop: isMobile ? 20 : 41,
    },
    body1: {
        marginLeft: isMobile ? 20 : 64,
        marginTop: isMobile ? 21 : 65,
        color: '#162946'
    },
    footerImg: {
        marginLeft: isMobile ? 24 : 65,
        marginTop: isMobile ? 48 : 236,
    },
    marg1: {
        marginTop: 30,
    },
    marg2: {
        marginTop: 22,
    },
    typography: {
        height: 52,
        width: 308,
        marginLeft: 64,
        marginTop: 59.62,
        fontFamily: 'Proxima Nova',
        fontSize: 16,
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '26px',
        letterSpacing: '0em',
        textAlign: 'left',
    },
    copyRight: {
        marginTop: 14,
        marginLeft: isMobile ? 20 : 61,
        color: '#9FABBC'
    },
    filterIcon: {
        marginRight: 20
    },
    
    clearBtnText: {
        fontWeight: 600,
        fontSize: 16
    },
    footerBox: {
        position: 'absolute',
        top: 911,
        marginTop: isMobile? 2829: 0,
        backgroundColor: '#E3EFFE00',
        color: '#162946'
    }

}));

const FilterMenu = ({ vacancies, direction, position, stack, salary, city, searched, total }) => {
    const classes = useStyles();
    const { request } = useHttp();
    const currentFilter = useSelector((state) => state.filterReducer);
    const [filterHidden, setFilterHidden] = useState(false);
    const [filterFilled, setFilterFilled] = useState(false);
    const [placeHolderMob, setPlaceHolderMob] = useState(false);

    const clickHandler = async () => {
        searched(true);
        setFilterHidden(true);
        currentFilter.vacancies = [];
        request.params = currentFilter;
        request.params.page = 1;
        const response = await request(
            `/filter/filtered`,
            'get',
            currentFilter
        );

        if (response && !response.error) {
            setPlaceHolderMob(true);
            total(response.total);
            return vacancies(response.vacancies);
        }
    };

    useEffect(() => {
        getDefaults();
    }, []);


    const getDefaults = async () => {
        const response = await request(
            `/filter/default`,
            'get',
        );

        if (response && !response.error) {
            setPlaceHolderMob(true);
            return vacancies(response.vacancies);
        }
    };

    const clearFilter = () => {
        setFilterFilled(false);
        direction(null);
        position(null);
        stack(null);
        salary(null);
        city(null);
        localStorage.clear();
    }

    const showFilter = () => {
        setFilterHidden(false);
    };

    useEffect(() => {
        if ((currentFilter.direction && currentFilter.direction.name) ||
            (currentFilter.stack && currentFilter.stack.length) ||
            currentFilter.salary ||
            (currentFilter.city&&currentFilter.city.id)
        ) {
            setFilterFilled(true);
        }
    }, [currentFilter]);

    return (
        <Grid
            container
            direction="column"
            className={classes.root}>
            <Box xs={isMobile ? 12 : 3}
                display="flex"
                justifyContent="flex-start"
                alignItems="flex-start"
            >
                <img
                    className={classes.img}
                    src={label}
                    alt="label"
                />
            </Box>
            <Collapse in={isMobile && filterHidden}>
                <Box xs={12}>
                    <Button className={classes.searchBtn} variant="contained" color="primary" onClick={() => showFilter()} startIcon={<img
                        className={classes.filterIcon}
                        src={filter}
                        alt="filter"
                    />}>
                        <Typography variant="caption" display="block">
                            Фильтры
                        </Typography>
                    </Button>
                </Box>
            </Collapse>
            <Collapse in={!(isMobile && filterHidden)}>
                <Box
                    display="flex"
                    justifyContent="left"
                    alignItems="flex-start"

                >
                    <Typography variant="body1" display="block" className={classes.body1}>
                        Выберите должность, стек, зарплату <br/>и создайте подборку для себя
                    </Typography>
                </Box>
                <Box xs={isMobile ? 12 : 3} className={classes.marg1}>
                    <Direction />
                </Box>
                <Box xs={isMobile ? 12 : 3} className={classes.marg2}>
                    <Position />
                </Box>
                <Box xs={isMobile ? 12 : 3} className={classes.marg2}>
                    <Stack />
                </Box>
                <Box xs={isMobile ? 12 : 3} className={classes.marg2}>
                    <Salary />
                </Box>
                <Box xs={isMobile ? 12 : 3} className={classes.marg2}>
                    <Currency />
                </Box>
                <Box xs={isMobile ? 12 : 3} className={classes.marg2}>
                    <City />
                </Box>
                <Box xs={isMobile ? 12 : 3} className={classes.radiogr} >
                    <Onsite />
                </Box>
                <Box xs={isMobile ? 12 : 3}>
                    <Button className={filterFilled ? classes.searchBtn : classes.searchBtnEmpty} variant="contained" color="primary" onClick={() => clickHandler()} >

                        Искать вакансии

                    </Button>
                </Box>
                <Collapse in={isMobile && filterFilled}>
                    <Box xs={isMobile ? 12 : 3}>
                        <Button className={classes.clearBtn} variant="contained" onClick={() => clearFilter()} >
                            Сбросить все
                        </Button>
                    </Box>
                </Collapse>
                <Box xs={isMobile ? 12 : 3}>
                    <Typography variant="caption" display="block" className={classes.registrationLinkGroup}>
                        <Link href="https://app.headz.io/" className={classes.regLink}>
                            Зарегистрироваться
                        </Link>
                        <Link href="https://app.headz.io/" className={classes.loginLink}>
                            Войти
                        </Link>
                    </Typography>
                </Box>

            </Collapse>
            {isMobile && placeHolderMob ? <SearchResultMob /> : <Box></Box>}
            <Box className={classes.footerBox}>
                <Box xs={12} className={classes.footerImg}>
                    <img

                        src={robot}
                        alt="robot"
                    />
                </Box>
                <Box xs={isMobile ? 12 : 3} justifyContent="left" className={classes.footer}>
                    <Typography variant="caption" display="block" gutterBottom>
                        Headz.io – умный сервис <br /> трудоустройства лучших IT-специалистов
                    </Typography>
                </Box>
                <Box xs={isMobile ? 12 : 3}>
                    <Typography variant="caption" display="block" gutterBottom>
                        <Link href="https://headz.io/" className={classes.aboutLink}>
                            О сервисе
                        </Link>
                        <Link href="#" className={classes.emailLink} onClick={() => window.open('mailto:hello@headz.io?')}>
                            hello@headz.io
                        </Link>
                    </Typography>
                </Box>
                <Box xs={isMobile ? 12 : 3} justifyContent="left" >
                    <Typography variant="caption" display="block" gutterBottom className={classes.copyRight}>
                        © {new Date().getFullYear()} ООО «Гет ИТ»
                    </Typography>
                </Box>
            </Box>
        </Grid>
    );
}

const mapStateToProps = state => ({
    vacancies: state.vacancies,
    direction: state.direction,
    position: state.position,
    stack: state.stack,
    salary: state.salary,
    city: state.city,
    searched: state.searched,
    total: state.total,
});

export default connect(mapStateToProps, { vacancies, direction, position, stack, salary, city, searched, total })(FilterMenu)